module.exports = __webpack_public_path__ + "media/images/search-modal-header-677bec3f59e051bb58ad5429a670ca31.jpg";